
import React, { useEffect, useState, useRef } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { useNavigate } from 'react-router-dom';
import Ben_Ver_Abstract_Fps from './Ben_Ver_Abstract_Fps';

const version_abs1 = async (dist_code) => {

  const response = await fetch(
    `${process.env.REACT_APP_URL_SIDE}/api/beneficiary/officecount`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        dist_code: dist_code
      })
    }
  );

  const data = await response.json();
  return data;
};

const Ben_Ver_Abstract_Ofice = ({ dist_code }) => {

  const [reportData, setReportData] = useState([]);
  const detailsRRef = useRef(null);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tabHeading, setTabHeading] = useState(null);
  const fpstab = useRef(null); // Use ref to scroll to this div
  const navigate = useNavigate(); const [renderContentt, setRenderContentt] = useState(null);


  const handleOfficeClick = (dist_code, afso_code) => {
    setRenderContentt(null);
    setTimeout(() => {
      setRenderContentt(<Ben_Ver_Abstract_Fps dist_code={dist_code} afso_code={afso_code} />);
    }, 10);
  };


  useEffect(() => {
    const getData = async () => {
      try {
        console.log(dist_code + ">>office  >dist_code");
        const response_data = await version_abs1(dist_code);
        setTabHeading(response_data.heading);

        if (response_data.data.length > 0) {
          setReportData(response_data.data);
        } else {
          setReportData([]);
        }

      } catch (errorr) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    getData();
  }, [dist_code]);

  useEffect(() => {
    if (!loading && !error && reportData.length > 0 && detailsRRef.current) {
      detailsRRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [loading, error, reportData]);

  if (loading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}><Box sx={{ display: 'flex' }}>
      <CircularProgress />
    </Box></div>
  }
  if (error) {
    return <div class="mainhead" align="center">
      Internal Error
    </div>
  }
  if (reportData.length === 0) {
    return <div class="mainhead" align="center">
      No data found
    </div>
  }

 const totals = reportData.reduce(
  (acc, item) => {
    acc.today_total_app += item.today_ekyc || 0;
    acc.today_app_today += item.app_today || 0;
    acc.month_month_ekyc += item.month_ekyc || 0;
    acc.month_app_month += item.app_month || 0;
    acc.total_total_ekyc += item.total_ekyc || 0;
    acc.total_total_app += item.total_app || 0;

    return acc;
  },
  {
    today_total_app: 0,
    today_app_today: 0,
    month_month_ekyc: 0,
    month_app_month: 0,
    total_total_ekyc: 0,
    total_total_app: 0,
  }
);

  return (
    <>
      <br />
      <table ref={fpstab} align="center" width="50%" border={1}>
        <thead>
          <th className="tableheader" colSpan={8}>{tabHeading}</th>
          <tr className="tableheader">
            <th rowspan="3">Sl.No</th>
            <th rowspan="3">office</th>
            <th colspan="4">Performed</th>
            <th rowspan="2" colspan="2" >Total</th>
          </tr>
       
          <tr class="tableheader">
            <th colspan="2" >Today</th>
            <th colspan="2" >current month</th>
          </tr>

          <tr class="tableheader">
            <th>key Register</th>
            <th>New App</th>
            <th>key Register</th>
            <th>New App</th>
            <th>key Register</th>
            <th>New App</th>
          </tr>
        </thead>


        <tbody>
          {reportData.map((item, index) => {
            return (
              <tr key={item.office_code}>
                <td style={{ textAlign: 'center' }}>{index + 1}</td>
                <td align="left">
                  <a style={{ cursor: 'pointer', color: 'blue' }} onClick={() => handleOfficeClick(item.dist_code, item.afso_code)}>
                    {item.afso_name_en}
                  </a>
                </td>
                  <td style={{ textAlign: 'right' }}>  {item.today_ekyc ?? 0}</td>
                  <td style={{ textAlign: 'right' }}>{item.app_today ?? 0}</td>
                  <td style={{ textAlign: 'right' }}>{item.month_ekyc ?? 0}</td>
                  <td style={{ textAlign: 'right' }}>{item.app_month ?? 0}</td>
                  <td style={{ textAlign: 'right' }}>{item.total_ekyc ?? 0}</td>
                  <td style={{ textAlign: 'right' }}>{item.total_app ?? 0}</td>
              </tr>
            );
          })}
          <tr class="tableheader">

            <td colSpan={2} style={{ textAlign: 'center', fontWeight: 'bold' }}>Total</td>
               <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.today_total_app ?? 0}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.today_app_today ?? 0}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.month_month_ekyc ?? 0}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.month_app_month ?? 0}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.total_total_ekyc ?? 0}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.total_total_app ?? 0}</td>
                     
          </tr>
        </tbody>
      </table>
     
      <div id="detailsERR" ref={detailsRRef}>{renderContentt}</div>

      <br /><br />

    </>
  );
};

export default Ben_Ver_Abstract_Ofice;
